var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Button, FormHelper, Grid, GridColumn, PassField, Separator, TextField } from 'telia-front-react';
import { observer } from 'mobx-react';
import { createGaEvent } from '../util/GaUtil';
import { injectStores } from '../util/StoresUtil';
import { action } from 'mobx';
let CustomerServicePassword = class CustomerServicePassword extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "personPasswordStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "MAX_PASSWORD_LENGTH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 8
        });
        Object.defineProperty(this, "onSaveClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.personPasswordStore.updatePassword();
                createGaEvent({
                    eventCategory: 'Iseteenindus - Konto',
                    eventAction: 'Isikuandmed',
                    eventLabel: 'customer-service-password-tab - button.save'
                });
            }
        });
    }
    componentDidMount() {
        this.personPasswordStore.loadPersonPassword();
    }
    render() {
        const store = this.personPasswordStore;
        const { translate, translateDiilGlobal } = this.translateStore;
        return (React.createElement(React.Fragment, null,
            React.createElement("p", null, translate('personPassword.info')),
            React.createElement(Separator, { spacing: "small", color: "invisible" }),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { width: ['md-4', 'sm-8', 'xs-12'] },
                    React.createElement(PassField, { id: "password", label: translate('personPassword.label'), value: store.newPassword.password, onChange: store.changePassword, isInvalid: !this.isPasswordValid(), errorMessage: !this.isPasswordValid() ? translate('personPassword.errors.PASSWORD_TOO_LONG') : undefined }),
                    React.createElement(Separator, { spacing: "small", color: "invisible" }),
                    React.createElement(TextField, { id: "password-hint", label: translate('personPassword.hintLabel'), value: store.newPassword.passwordHint, onChange: store.changeHint }),
                    this.renderSuccessfulSubmitFormHelper(),
                    React.createElement(Separator, { spacing: "small", color: "invisible" }),
                    React.createElement(Button, { text: translateDiilGlobal('button.save'), iconLeft: "#save", disabled: !store.canUpdatePassword || !this.isPasswordValid(), onClick: this.onSaveClick })))));
    }
    isPasswordValid() {
        return this.personPasswordStore.newPassword.password.length < this.MAX_PASSWORD_LENGTH;
    }
    renderSuccessfulSubmitFormHelper() {
        const { translate } = this.translateStore;
        if (this.personPasswordStore.isSaveSuccessful) {
            return React.createElement(FormHelper, { text: translate('personPassword.saveSuccessful'), type: "valid" });
        }
    }
};
__decorate([
    action.bound
], CustomerServicePassword.prototype, "onSaveClick", void 0);
CustomerServicePassword = __decorate([
    injectStores,
    observer
], CustomerServicePassword);
export default CustomerServicePassword;
